// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a4b116a1","313":"da743bdd","322":"702bd3ca","549":"71feec97"}[chunkId] + ".chunk.js";
};